import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import converter from './converter';
import * as api from './api';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCultures.toString(),
            defaultSaga({
                constants: constants.getCultures,
                api: api.getCultures
            })
        ),
        yield takeLatest(
            constants.getCulture.toString(),
            defaultSaga({
                constants: constants.getCulture,
                api: api.getCulture
            })
        )
    ]);
}